import { render, staticRenderFns } from "./SidecartLineItem.vue?vue&type=template&id=353efa4e&scoped=true&lang=pug&"
import script from "./SidecartLineItem.vue?vue&type=script&lang=js&"
export * from "./SidecartLineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353efa4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353efa4e')) {
      api.createRecord('353efa4e', component.options)
    } else {
      api.reload('353efa4e', component.options)
    }
    module.hot.accept("./SidecartLineItem.vue?vue&type=template&id=353efa4e&scoped=true&lang=pug&", function () {
      api.rerender('353efa4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/sidecart/SidecartLineItem.vue"
export default component.exports